// Starts at -1 because router.subscribe('onLoad') fires on the initial page load.
// After that first fire, navCount is 0 (no in-app history).
// Each subsequent navigation increments it to 1+ (has in-app history).
let navCount = -1;

export function trackNavigation() {
  navCount++;
}

export function hasAppHistory() {
  return navCount > 0;
}
